import { render, staticRenderFns } from "./instBindigPayment.vue?vue&type=template&id=5755eec8&scoped=true"
import script from "./instBindigPayment.vue?vue&type=script&lang=js"
export * from "./instBindigPayment.vue?vue&type=script&lang=js"
import style0 from "./instBindigPayment.vue?vue&type=style&index=0&id=5755eec8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5755eec8",
  null
  
)

export default component.exports